<template>
  <div class="photo-album card">
    <div class="row">
      <div class="col col-xs-12 col-md-6">
        <div class="photo-album__item">
          <img src="@/assets/example.jpg" />
        </div>
      </div>
      <div class="col col-xs-12 col-md-6">
        <div class="photo-album__item">
          <img src="@/assets/example-2.jpg" />
        </div>
      </div>
      <div class="col col-xs-12">
        <div class="photo-album__item photo-album__item--last">
          <img src="@/assets/example-1.jpg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventPhotoAlbum',
  props: {
    eventId: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.photo-album {
  &__item {
    margin-bottom: var(--global-dimension-size-250);

    &--last {
      margin-bottom: 0;
    }

    img {
      max-width: 100%;
    }
  }
}
</style>
